import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import Axios from "axios";
import { apiRoutes, environment } from "../../auth/apiRoute";
const gutterLayout = { xs: 8, sm: 16, md: 24, lg: 32 };
const layout = {
  wrapperCol: {
    span: 24,
  },
};
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

export default function Profile(props) {
  const [form] = Form.useForm();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [confirmationMessage, setConfirmationMessage] = useState();
  useEffect(() => {}, []);
  const [myProfile, setMyProfile] = useState({});

  useEffect(() => {
    getMyProfile();
  }, []);
  const getMyProfile = async () => {
    try {
      const response = await Axios.post(apiRoutes[environment].getprofile);

      if (response.status == 200) {
        setMyProfile(response.data);
        form.setFieldsValue({ user: response.data });
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const onFinish = async (values) => {
    submitInfo(values);
  };

  const submitInfo = async (values) => {
    setLoading(true);
    var newUser;
    newUser = values;

    newUser.id = myProfile._id;
    newUser.user.uid = props.user.uid;
    try {
      const response = await Axios.post(
        apiRoutes[environment].updateprofile,
        newUser
      );
      console.log(response);
      if (response.status == 200) {
        props.setCurrentStep();
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  return (
    <div>
      <Form
        form={form}
        {...layout}
        name="nest-messages"
        layout="vertical"
        onFinish={onFinish}
        validateMessages={validateMessages}
        initialValues={{ user: user }}
      >
        <Row gutter={gutterLayout}>
          <Col span={24}>
            <Form.Item
              name={["user", "firstName"]}
              label="First Name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name={["user", "lastName"]}
              label="Last Name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={gutterLayout}>
          <Col xs={24} md={24}>
            <Form.Item
              name={["user", "email"]}
              label="Email"
              rules={[
                {
                  type: "email",
                },
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={gutterLayout}>
          <Col xs={12} md={12}>
            <Form.Item name={["user", "phone"]} label="Phone">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name={["user", "title"]} label="Position">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={gutterLayout}>
          <Col span={24}>
            <Form.Item>
              <Button
                type="primary"
                disabled={loading ? true : false}
                htmlType="submit"
                block
              >
                Confirm
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
